import NhoSurveySlot from "./NhoSurveySlot";
import ItamSlot from "./ItamSlot";
import CocSlot from "./CocSlot";
import HappinessSurveySlot from "./HappinessSurveySlot";
import EventRegistrationSlot from "./EventRegistrationSlot";

/**
 * Client registry of the custom-form slots: custom_key -> body component (SPEC 7.4 / 21.1).
 *
 * The keys mirror `config/broadcasts.php` `custom_forms` on the server, in registry order. A
 * `kind = custom` item in the pop-up queue is rendered by CustomFormSlot, which looks its
 * component up here by `item.custom_key` and hands it:
 *
 *   { item, user, settings, payload, onComplete, onDefer, onError }
 *
 * Each slot renders only the body (the BroadcastModal frame owns title and chrome), saves
 * through the same endpoint the hand-coded Dashboard modal used, then calls onComplete() so
 * the frame posts `completed` and advances. EVA is a phase-2 built-in form (SPEC 16), not a key.
 */
const customForms = {
  nho_survey: NhoSurveySlot,
  itam: ItamSlot,
  coc: CocSlot,
  happiness_survey: HappinessSurveySlot,
  event_registration: EventRegistrationSlot,
};

export default customForms;
